import React from 'react';
import { ArrowRight, Lock, Zap } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  variant?: 'primary' | 'secondary';
  size?: 'default' | 'large' | 'xl';
  subtext?: string;
  showIcon?: boolean;
  pulse?: boolean;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  variant = 'primary',
  size = 'default',
  subtext,
  showIcon = true,
  pulse = false
}: CTAButtonProps) {
  const baseStyles = 'inline-flex flex-col items-center justify-center font-bold transition-all duration-300 rounded-xl shadow-lg hover:shadow-2xl transform hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-offset-2 relative overflow-hidden group';
  const variants = {
    primary: 'bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white focus:ring-orange-500 border-b-4 border-orange-800 active:border-b-0 active:translate-y-1',
    secondary: 'bg-green-500 hover:bg-green-600 text-white focus:ring-green-500 border-b-4 border-green-700 active:border-b-0 active:translate-y-1'
  };
  const sizes = {
    default: 'px-6 py-3 text-lg',
    large: 'px-8 py-4 text-xl md:text-2xl',
    xl: 'px-10 py-5 text-2xl md:text-3xl w-full md:w-auto'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const pulseClass = pulse ? 'animate-pulse' : '';
  const scrollToCheckout = (e: React.MouseEvent) => {
    e.preventDefault();
    const checkoutSection = document.getElementById('checkout');
    if (checkoutSection) {
      checkoutSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <a href="#checkout" onClick={scrollToCheckout} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${pulseClass} ${className}`} data-id="element-1">
      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-10" data-id="element-2" />

      <div className="flex items-center justify-center gap-2 relative z-20" data-id="element-3">
        {showIcon && <span className="text-2xl" data-id="element-4">👉</span>}
        <span className="tracking-wide" data-id="element-5">{children}</span>
        {showIcon && <ArrowRight className="w-6 h-6 md:w-8 md:h-8 animate-bounce-subtle" data-id="element-6" />}
      </div>

      {subtext && <span className="text-xs md:text-sm font-medium opacity-90 mt-1 flex items-center gap-1 relative z-20" data-id="element-7">
          <Lock className="w-3 h-3" data-id="element-8" /> {subtext}
        </span>}
    </a>;
}